import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[passwordStrength]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PasswordStrengthValidatorDirective, multi: true }],
    standalone: false,
})
export class PasswordStrengthValidatorDirective implements Validator {
    @Input() required: boolean = false;

    validate(control: AbstractControl) {
        if (!control.value && !this.required) {
            return null;
        }

        let error = false;
        const result: ValidationErrors = {};

        if (!control.value || control.value.length < 6) {
            result.minlength = true;
            error = true;
        }

        if (
            !control.value ||
            !(/\d+/.test(control.value) || /[!"#\$%&'\(\)\*\+,\-\.\/:;<=>\?@\[\]\^_`\{\|}~]+/.test(control.value))
        ) {
            result.passwordStrength = true;
            error = true;
        }

        return error ? result : null;
    }
}
